<div #field class="pickerButton" (click)="toggle()"><span *ngIf="selectedItem">{{prefix + selectedItem | trans}}</span><span *ngIf="!selectedItem">&nbsp;</span><svg-icon name="drop-down"></svg-icon></div>
<drop-down #popup [for]="field" [fullHeight]="false" className="enumDropDown">
  <div class="dropDownContent" *ngIf="items">
    <div class="enumItem" *ngFor="let item of items" [ngClass]="{selected: selectedItem === item}" (click)="selectEnumItem(item)">{{prefix + item | trans}}</div>
  </div>
</drop-down>
